/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SyncDeviceCreate } from '../models/SyncDeviceCreate';
import type { SyncDeviceCreated } from '../models/SyncDeviceCreated';
import type { SyncDeviceTokenRegenerated } from '../models/SyncDeviceTokenRegenerated';
import type { SyncDeviceUpdate } from '../models/SyncDeviceUpdate';
import type { SyncDeviceView } from '../models/SyncDeviceView';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SyncAdminService {

    /**
     * Liste aller Sync-Geräte - Admin only
     * @returns SyncDeviceView Successful Response
     * @throws ApiError
     */
    public static listSyncDevicesSyncAdminDevicesGet(): CancelablePromise<Array<SyncDeviceView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sync/admin/devices',
        });
    }

    /**
     * Neues Sync-Gerät anlegen - Admin only
     * @param requestBody
     * @returns SyncDeviceCreated Successful Response
     * @throws ApiError
     */
    public static createSyncDeviceSyncAdminDevicesPost(
        requestBody: SyncDeviceCreate,
    ): CancelablePromise<SyncDeviceCreated> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sync/admin/devices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Token eines Sync-Geräts neu generieren - Admin only
     * @param deviceId
     * @returns SyncDeviceTokenRegenerated Successful Response
     * @throws ApiError
     */
    public static regenerateSyncDeviceTokenSyncAdminDevicesDeviceIdRegeneratePost(
        deviceId: number,
    ): CancelablePromise<SyncDeviceTokenRegenerated> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sync/admin/devices/{device_id}/regenerate',
            path: {
                'device_id': deviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Sync-Gerät löschen - Admin only
     * @param deviceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteSyncDeviceSyncAdminDevicesDeviceIdDelete(
        deviceId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/sync/admin/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Sync-Gerät aktualisieren - Admin only
     * @param deviceId
     * @param requestBody
     * @returns SyncDeviceView Successful Response
     * @throws ApiError
     */
    public static updateSyncDeviceSyncAdminDevicesDeviceIdPatch(
        deviceId: number,
        requestBody: SyncDeviceUpdate,
    ): CancelablePromise<SyncDeviceView> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sync/admin/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
